module.exports = __webpack_public_path__ + "static/media/aim.b81fe48a.svg";